import cx from 'classnames';
import React, { FC } from 'react';

import { HelpTooltip } from 'components';

type Props = {
  title: string;
  tooltip?: React.ReactNode;
  className?: string;
};

export const DataGridColumnHeader: FC<Props> = ({
  title,
  tooltip,
  className,
}) => (
  <div className={cx('tw-flex tw-items-center', className)}>
    <div>{title}</div>
    {tooltip && (
      <HelpTooltip
        title={tooltip}
        classes={{ popper: 'tw-whitespace-pre-line' }}
      />
    )}
  </div>
);
